export const MenuOptions = {
	GENERAL: "GENERAL",
	USERS: "USERS"
} as const;

export type MenuOptionKey = (typeof MenuOptions)[keyof typeof MenuOptions];
